<lib-sticky-modal>
  <lib-sticky-header [stickyCollectionKey]="'menu-template-save-confirmation'" [stickyZ]="10" [stickyOrder]="0">
    <div class="modal-header no-bottom-border" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="modal-title" ngbAutofocus>Required Location Changes</div>
    </div>
  </lib-sticky-header>
  <lib-sticky-body>
    <div
      libStickyAutoPosition
      class="desc-and-search"
      fxLayout="column"
      [stickyCollectionKey]="'menu-template-save-confirmation'"
      [stickyOrder]="1"
      [stickyZ]="10"
      [style.gap.rem]="1">
      <div class="modal-description">
        <p>The following changes will be made to this templates required locations.</p>
      </div>
      <hr class="no-margin" />
      <app-search-with-look-ahead
        [placeHolder]="'Search for changed required location'"
        [lookAheadItems]="viewModel.addedOrRemovedLocations$ | async"
        [searchTheseProperties]="['name', 'address', 'city', 'state', 'country']"
        [disablePopper]="true"
        [nLookAheadItems]="10000"
        [outputAllItemsWhenSearchIsEmpty]="true"
        (searchText)="viewModel.connectToSearchString($event)"
        (lookAheadHits)="viewModel.connectToSearchedLocations($event)">
      </app-search-with-look-ahead>
      <div *ngIf="!(viewModel.searchedLocations$ | async)?.length" class="empty-search-state">No locations found.</div>
    </div>
    <div class="menu-template-required-locations-save-confirmation-container">
      <app-template-location-selection-group
        *ngFor="
          let grouping of viewModel.searchedLocationsGroupedByProvince$ | async | keyvalue;
          trackBy: viewModel.trackById
        "
        [province]="grouping?.key"
        [locations]="grouping?.value"
        [viewOnlyMode]="true"
        [showAddedOrRemovedStatus]="true"
        [expanded]="true"
        [originalRequiredLocationIds]="viewModel.originalRequiredLocationIds$ | async"
        [updatedRequiredLocationIds]="viewModel.updatedRequiredLocationIds$ | async">
      </app-template-location-selection-group>
    </div>
  </lib-sticky-body>
  <lib-sticky-footer>
    <lib-button-layout>
      <lib-button-neutral (buttonClicked)="cancel()"> Cancel </lib-button-neutral>
      <lib-button-primary (buttonClicked)="close(true)"> Save Template </lib-button-primary>
    </lib-button-layout>
  </lib-sticky-footer>
</lib-sticky-modal>
